import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ReactMarkdown from "react-markdown";

export default function LearningStructure({ element, className = "" }) {
  return (
    <section
      className={`layout__color_primary position-relative overflow-hidden ${className}`}
    >
      <Container fluid>
        <Row>
          <Col xs={12} md={6}>
            <div className="learnCard d-flex flex-column gap-new layout__bg_secondary h-100">
              <h2 data-aos="fade-up">{element.theorie.title}</h2>
              {(element.theorie.intro || element.theorie.description) && (
                <div>
                  {element.theorie.intro && (
                    <p
                      data-aos="fade-up"
                      className="layout_text layout_text__medium mb-4"
                    >
                      {element.theorie.intro}
                    </p>
                  )}
                  {element.theorie.description && (
                    <p data-aos="fade-up" className="layout_text">
                      {element.theorie.description}
                    </p>
                  )}
                </div>
              )}
              {Array.isArray(element.theorie.items) && (
                <div className="d-flex flex-column gap-y-20">
                  {element.theorie.items.map((item, index) => {
                    return (
                      <div key={`point_${index}`} className="">
                        {item.title && (
                          <h4
                            className="layout_title layout_title__subitem text-uppercase fw-400 mb-3"
                            data-aos="fade-up"
                          >
                            {item.title}
                          </h4>
                        )}
                        <ReactMarkdown
                          data-aos="fade-up"
                          className="layout_text mb-0"
                        >
                          {item.description}
                        </ReactMarkdown>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="learnCard d-flex flex-column gap-new layout__bg_primary h-100">
              <h2 data-aos="fade-up">{element.praxis.title}</h2>
              {(element.praxis.intro || element.praxis.description) && (
                <div>
                  {element.praxis.intro && (
                    <p
                      data-aos="fade-up"
                      className="layout_text layout_text__medium mb-4"
                    >
                      {element.praxis.intro}
                    </p>
                  )}
                  {element.praxis.description && (
                    <p data-aos="fade-up" className="layout_text">
                      {element.praxis.description}
                    </p>
                  )}
                </div>
              )}
              {Array.isArray(element.praxis.items) && (
                <div className="d-flex flex-column gap-y-20">
                  {element.praxis.items.map((item, index) => {
                    return (
                      <div key={`point_${index}`} className="">
                        {item.title && (
                          <h4
                            className="layout_title layout_title__subitem text-uppercase fw-400 mb-3"
                            data-aos="fade-up"
                          >
                            {item.title}
                          </h4>
                        )}
                        <ReactMarkdown
                          data-aos="fade-up"
                          className="layout_text mb-0"
                        >
                          {item.description}
                        </ReactMarkdown>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
